/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unneeded-ternary */
/* eslint-disable no-underscore-dangle */
import ProductFamily from 'models/ProductFamily';
import IsEmpty from 'lodash.isempty';
/**
 * Hold information about a product
 */
class Product {
	constructor(prodId, product = {}, family = new ProductFamily()) {
		this.productId = prodId;
		this.approvedTotalReviews = product.approvedTotalReviews;
		this.averageReview = product.averageReview;
		this.currentPrice = product.currentPrice;
		this.shortDescription = product.shortDescription;
		this.fullDescription = product.fullDescription;
		this.family = family;
		this.isSoftkit = !IsEmpty(product.kitComponents) && product.kitComponents[0].id !== '';
		this.addonProducts = product.addonProducts;
		this.kitComponents = product.kitComponents;
		this.msrp = product.msrp;
		this.name = product.name || family.description;
		this.normalKitPrice = product.normalKitPrice;
		this.onDisplay = product.onDisplay;
		this.parentCategoryId = product.parentCategoryId || family.parentCategoryId;
		this.pictureUrl = product.pictureUrl;
		this.pictureUrls = product.pictureUrls;
		this.price = product.price;
		this.oldPrice = product.oldPrice;
		this.productReviews = product.productReviews || { Items: [] };
		this.relatedProducts = product.relatedProducts;
		this.sku = product.sku || family.sku;
		this.stockQuantity = product.stockQuantity;
		this.store = product.store;
		this.vendorId = product.vendorId;
		this.vendorName = product.vendorName;

		this.selectedComponents = [];
		this.productAttributes = product.productAttributes || [];
		this.specAttributes = product.specAttributes || [];

		if (this.isSoftkit) {
			this.buildOutSoftKitComponents(this);
		}

		// This is a workaround for the fact that eSTORIS does not store product attribute values with each kit component
		// item. Since we have to go through the productAttributes anyway to mark all standard products as selected
		// I am just trying to save some time by creating a lookup table.
		// Note: this does not work for soft kits because soft kits can have multiple different components
		// with the exact same SKU.
		// given a SKU return the product attribute value
		this._componentSKUtoValue = new Map();

		// seed default selectedComponents - with families, default first member
		if (!IsEmpty(this.family.members)) {
			this.family.members.forEach(member => {
				// product family members can have one or more attribute values
				// set the key as the sku and the values in an array
				const memberAttributes = [];
				member.attributeValues.forEach(attributeValue => {
					const familyAttribute = this.family.attributes.find(
						attribute => attribute.textPrompt === attributeValue.Key,
					);
					const value = familyAttribute.attributeValues.find(
						element => element.attributeValueName === attributeValue.Value,
					);
					memberAttributes.push(value.attributeValueId);
				});
				this._componentSKUtoValue.set(member.productId, memberAttributes);
			});
			this.addSelectedComponent(this.family.members[0].productId);
		}

		if (!IsEmpty(this.family.products)) {
			this.family.products.forEach(product => {
				if (!IsEmpty(product.kitComponents)) {
					product.isSoftkit = true;
				}
			});
		}
	}

	buildOutSoftKitComponents(product) {
		let currentItem;
		// Make a lookup table of SKU to currentPrice. Each item with the same SKU should have the same price.
		product._SKUtoPrice = new Map();
		product.kitComponents.forEach(kitComponent => {
			product._SKUtoPrice.set(kitComponent.id, kitComponent.currentPrice);
			if (!IsEmpty(kitComponent.replacementItems)) {
				kitComponent.replacementItems.forEach(replacementItem => {
					product._SKUtoPrice.set(replacementItem.id, replacementItem.adjustmentPrice);
				});
			}
		});

		product.softkitComponents = [];
		// Create new softkitComponent objects that have all the information we need to correctly
		// display a soft kit and calculate the price, and add to this.softkitComponents array
		product.productAttributes.forEach(attribute => {
			let preSelected; // attributeValueId of preselected component
			let componentType = 'standard';
			const componentItems = [];
			attribute.attributeValues.forEach(attributeValue => {
				const itemType = attributeValue.storisProductId.split('^')[1];

				// Determine component type by looking at the item types.
				// Standard: all items are standard
				// Replacement: one item is standard, the rest are replacement
				// Addon: all items are addon
				switch (itemType) {
					case 'standard':
						// if this is the standard product, set preSelected to this index
						preSelected = attributeValue.attributeValueId;
						break;
					case 'replacement':
						// Mark that this component has replacement items
						componentType = 'replacement';
						break;
					case 'addon':
						// Mark that this component has addon items
						componentType = 'addon';
						break;
					case undefined:
						componentType = 'addon';
						break;
					default:
						break;
				}

				// Get values and create object for current item
				const sku =
					attributeValue.storisProductId.split('^')[2] === undefined
						? attributeValue.storisProductId
						: attributeValue.storisProductId.split('^')[2];
				const currentPrice = product._SKUtoPrice.get(attributeValue.storisProductId);
				const quantity = attributeValue.attributeValueQuantity;
				const name = attributeValue.attributeValueName;
				const id = attributeValue.attributeValueId;
				componentItems.push({
					id,
					componentMappingId: attribute.attributeMappingId,
					name,
					quantity,
					sku,
					currentPrice,
				});
			});
			// Don't add addon items to the softkitComponents array
			if (componentType !== 'addon') {
				product.softkitComponents.push({
					mappingId: attribute.attributeMappingId,
					currentSelection: componentType === 'replacement' ? preSelected : null,
					componentDescription: attribute.textPrompt,
					componentType,
					displayOrder: attribute.displayOrder,
					componentItems,
				});
			}
		});

		// Calculate the adjustmentPrice in a separate loop because we don't know
		// what the preselected items are until the first loop is done
		// also call addSelectedComponent on preselected items while we're at it
		if (this.sku.startsWith('PF*')) {
			currentItem = product;
			currentItem.addSelectedComponent = this.addSelectedComponent;
			currentItem.getKitItem = this.getKitItem;
		} else {
			currentItem = this;
		}
		currentItem.softkitComponents.forEach(component => {
			const standardItem = component.componentItems.find(
				item => item.id === component.currentSelection,
			);
			component.componentItems.forEach(item => {
				// Only set adjustment prices for replacement items
				if (component.componentType === 'replacement') {
					// eslint-disable-next-line no-param-reassign
					item.adjustmentPrice =
						item.currentPrice - standardItem.quantity / item.quantity * standardItem.currentPrice;
				}
				if (component.componentType === 'standard' || item.id === component.currentSelection) {
					currentItem.addSelectedComponent(item.id);
				}
			});
		});

		// Put the soft kit components array into order of displayOrder
		currentItem.softkitComponents.sort((a, b) => a.displayOrder - b.displayOrder);
	}

	getKitItem(id) {
		if (!this.softkitComponents) {
			return null;
		}

		const copyKitItem = kitItem => ({
			id: kitItem.id,
			componentMappingId: kitItem.componentMappingId,
			name: kitItem.name,
			quantity: kitItem.quantity,
			sku: kitItem.sku,
			currentPrice: kitItem.currentPrice,
		});

		// Find the item with the specified id in the softkitComponents array
		const item = this.softkitComponents.reduce(
			(accumulator, component) =>
				accumulator || component.componentItems.find(componentItem => componentItem.id === id),
			null,
		);
		return item ? copyKitItem(item) : null;
	}

	getProductFamilyKitItem(id) {
		if (!this.selectedComponents[0].kitComponents) {
			return null;
		}

		const copyKitItem = kitItem => ({
			id: kitItem[1].attributeValueId,
			componentMappingId: kitItem[0].attributeMappingId,
			name: kitItem[1].attributeValueName,
			quantity: kitItem[1].attributeValueQuantity,
			sku: kitItem[1].storisProductId.split('^')[2],
			currentPrice: null,
		});

		// Find the item with the specified id in the kitComponents array
		const kitItem = this.getProductAttribute(id);

		return copyKitItem ? copyKitItem(kitItem) : null;
	}

	getProductAttribute(id) {
		let foundProductAttribute = null;
		let foundReplacementItemAttributeValue = null;
		this.selectedComponents[0].productAttributes.forEach(productAttribute => {
			productAttribute.attributeValues.forEach(attributeValue => {
				if (attributeValue.attributeValueId === id) {
					foundProductAttribute = productAttribute;
					foundReplacementItemAttributeValue = attributeValue;
				}
			});
		});

		return [foundProductAttribute, foundReplacementItemAttributeValue];
	}

	/**
	 * Return the current price as configured based on currently configured settings
	 */
	calculatePrice() {
		let price = 0;
		if (IsEmpty(this.selectedComponents)) {
			price = this.currentPrice !== null ? this.currentPrice : 0;
		} else {
			price = this.selectedComponents.reduce(
				(total, selectedItem) =>
					total +
					(selectedItem.currentPrice === undefined
						? 0
						: selectedItem.currentPrice * selectedItem.quantity),
				0,
			);
		}
		return price;
	}

	/**
	 * add an item from the list of selected components
	 * @param {string} id - For product family, this is sku. For soft kit, this is attributeValueId.
	 */
	addSelectedComponent(id) {
		if (this.sku.startsWith('PF*')) {
			// this is a product family
			const selectedProduct = this.family.products.find(product => product.sku === id);
			if (selectedProduct === undefined) {
				const selectedProductFamilyMember = this.selectedComponents[0];
				if (selectedProductFamilyMember.isSoftkit) {
					const kitItem = this.getProductFamilyKitItem(id);
					if (kitItem) {
						if (selectedProductFamilyMember.selectedComponents === undefined) {
							selectedProductFamilyMember.selectedComponents = [];
						}

						selectedProductFamilyMember.selectedComponents.push(kitItem);
						if (this.selectedComponents[0].softkitComponents === undefined) {
							this.buildOutSoftKitComponents(this.selectedComponents[0]);
						}

						const component = this.selectedComponents[0].softkitComponents.find(
							comp => comp.mappingId === kitItem.componentMappingId,
						);
						component.currentSelection = id;
					}
				}
			} else {
				selectedProduct.productAttributeValue = this._componentSKUtoValue.get(id);
				this.selectedComponents.push(selectedProduct);
			}
		} else {
			const kitItem = this.getKitItem(id);
			if (kitItem) {
				if (this.selectedComponents === undefined) {
					this.selectedComponents = [];
				}
				this.selectedComponents.push(kitItem);
				const component = this.softkitComponents.find(
					comp => comp.mappingId === kitItem.componentMappingId,
				);
				component.currentSelection = id;
			}
		}
	}

	/**
	 * remove an item from the list of selected components
	 * @param {string} id - For product family, this is sku. For soft kit, this is attributeValueId.
	 */
	removeSelectedComponent(id) {
		const productFamilySoftKitMemberChange =
			this.sku.startsWith('PF*') &&
			this.selectedComponents[0].isSoftkit &&
			this.selectedComponents.length === 1
				? true
				: false;
		if (productFamilySoftKitMemberChange) {
			// this is an attempt to select replacement items on a product family soft kit item
			this.selectedComponents[0].selectedComponents.filter = this.selectedComponents.filter;
			this.selectedComponents[0].selectedComponents = this.selectedComponents[0].selectedComponents.filter(
				item => item.id !== id,
			);
		} else if (this.isSoftkit) {
			this.selectedComponents = this.selectedComponents.filter(item => item.id !== id);
		} else {
			this.selectedComponents = this.selectedComponents.filter(item => item.sku !== id);
		}
	}

	/**
	 * return the value of the spec attribute that is passed in. currently only used for dimensions.
	 * @param {string} name - The name of the spec attribute to return a value for.
	 */
	findSpecAttributes(name) {
		// Find the desired dimension in the spec attribute array
		const attribute = this.specAttributes.find(specAttribute => specAttribute.name === name);
		// We either found the attribute from the array, or we received back undefined.
		// If we found it, return its value, otherwise return its default value of 0.
		const attributeValue = attribute == null ? 0 : attribute.value;
		return attributeValue;
	}
}

export default Product;
